import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-org-form',
	imports: [CommonModule, FormsModule],
  providers: [DatePipe],
	templateUrl: './org-form.component.html',
	styleUrl: './org-form.component.scss',
})
export class OrgFormComponent {
  @Input() user: any;
  @Input() action: any;

  datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  localeDate: any = new Date().toLocaleDateString('en-IN');
  districts: any = null;

  base = 'organizations';		// important for API calls
  loading = false;
  isReadonly = true;
  frmDataX: any = {};
  frmData: any = {
		id: null, 
		org_name: '', 
		org_address: '', 
		org_state: '', 
		org_city: '', 
		org_pincode: '', 
		reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
		is_active: true,
    districts: ''
	};

  constructor(public dataService: DataService) {
    //
  }

  ngOnInit() {
    // Listen to changes continuously
    this.dataService.outerAction.subscribe((value: any) => {
      if(value) {
        if(value.component != 'organization') return;

        this.action = value.action;
        if(value.data) {
          this.frmData = Object.assign({}, value.data);
          if(this.frmData.org_state) {
            this.districts = this.dataService.getDist(this.frmData.org_state);
          }
          this.frmData.reg_date = this.frmData.reg_date.substr(0,10);
        } else {
          this.resetForm();
        }
        this.dataService.updateOuterAction(null);
      }
    });
	}

  ngOnChanges() {
    if(this.action) {
      switch(this.action) {
        case 'addnew':
          this.isReadonly = false;
          // this.frmDataSet();
          this.resetForm();
          break;
        case 'modify':
          this.isReadonly = false;
          this.frmDataSet();
          break;
        case 'save':
          this.doSave();
          this.isReadonly = true;
          break;
        case 'update':
          this.doUpdate();
          this.isReadonly = true;
          break;
        case 'cancel':
          this.isReadonly = true;
          this.resetForm();
          break;
        default:
          break;
      }

      this.action = '';
    }
  }

  frmDataSet() {
    if(this.frmData.org_name) {
      this.frmDataX = Object.assign({}, this.frmData);
    } else {
      this.frmDataX = {};
    }
  }

	resetForm() {
		this.frmData = {
      id: null, 
      org_name: '', 
      org_address: '', 
      org_state: '', 
      org_city: '', 
      org_pincode: '', 
      reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      is_active: true,
      districts: ''
		};
	}

  doSave() {
    this.loading = true;
    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		delete this.frmData.id;

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

}
